import type { GlideFC } from "lib/glide-fc";
import * as React from "react";
import GrowingEntryView from "../growing-entry/growing-entry-view";
import { OverlayEditorViewStyle } from "./overlay-editor-view-style";
export interface OverlayEditorViewProps {
    value: string;

    className?: string;
    placeholder?: string;

    onChange: (newValue: string) => void;
}
const autoFocusDelay = 500;

const OverlayEditorView: GlideFC<OverlayEditorViewProps> = p => {
    const { onChange, placeholder, value, className } = p;

    const inputRef = React.useRef<HTMLTextAreaElement>(null);

    const onInput = React.useCallback(
        (ev: React.ChangeEvent<HTMLTextAreaElement>): void => {
            onChange(ev.target.value);
        },
        [onChange]
    );

    React.useEffect(() => {
        const delayFocus = setTimeout(() => {
            if (inputRef.current !== null && inputRef.current !== document.activeElement) {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, "forward");
            }
        }, autoFocusDelay);

        return () => {
            clearTimeout(delayFocus);
        };
    }, []);

    return (
        <OverlayEditorViewStyle className={className}>
            <GrowingEntryView inputRef={inputRef} onChange={onInput} value={value} placeholder={placeholder} />
        </OverlayEditorViewStyle>
    );
};

export default OverlayEditorView;
